module.exports = __webpack_public_path__ + "img/truck.317f0214.svg";